var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Observable } from 'rxjs/Observable';
import { switchMap, take } from 'rxjs/operators';
var ListObservable = /** @class */ (function (_super) {
    __extends(ListObservable, _super);
    function ListObservable(ref$, storeBackend, source) {
        var _this = _super.call(this) || this;
        _this.ref$ = ref$;
        _this.storeBackend = storeBackend;
        _this.source = source;
        return _this;
    }
    ListObservable.prototype.push = function (object) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) { return _this.storeBackend.push(ref, object); }))
            .toPromise();
    };
    ListObservable.prototype.set = function (id, object) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) { return _this.storeBackend.set(ref, id, object); }))
            .toPromise();
    };
    ListObservable.prototype.update = function (id, object) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) { return _this.storeBackend.update(ref, id, object); }))
            .toPromise();
    };
    ListObservable.prototype.remove = function (id) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) { return _this.storeBackend.delete(ref, id); }))
            .toPromise();
    };
    return ListObservable;
}(Observable));
export { ListObservable };



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/list-observable.ts.pre-build-optimizer.js